<!-- 价格明细 -->
<template>
  <div class="price-details">
    <div class="price-details__header">价格明细</div>
    <!-- 价格明细 -->
    <div class="price-details__content">
      <p v-if="isFpcNeedAudit" class="price-details__empty fpc-audit">
        软硬结合板暂不支持自动计价
        <span>具体价格以审核为准</span>
      </p>
      <ul v-else-if="list.length > 0" class="price-details__list">
        <li 
          v-for="item in list" 
          :key="item.label"
          class="price-details__item"
        >
          <span class="price-details__item__label">
            {{ item.label }}
          </span>
          <span 
            class="price-details__item__value" 
            :style="{ color: item.color }"
          >
            <div v-if="item.slot === 'gch'" class="price-details__item__gch">
              {{ `${item.prefix || ''}${item.value || ''}` }}
              <BaseTipPopover 
                width="'460px'" 
                placement="top"
                :content="`
                  此优惠金额仅供参考，审核后满足以下条件可享此优惠工程费。\n
                  1）无“阻抗”\n
                  2）无“叠层结构”要求\n
                  3）制版文件仅有一个PCB源文件或一个gerber文件，无生产工艺说明文档\n
                  4）不包含订单备注\n
                  5）不包含3.5mil及以下的线宽线距 \n
                  6)  不包含:0.2mm及以下的最小孔径
                `" 
              >
                <span slot='reference' class="price-details__item__gch__reference">减</span>
              </BaseTipPopover>
            </div>
            <!-- 叠层结构费 -->
            <!-- <div v-else-if="item.slot === 'pressingfee'" class="price-details__item__pressingfee">
              {{ `${item.prefix || ''}${item.value || ''}` }}
              <img 
                class="price-details__item__pressingfee__hot" 
                :src="require('@@/assets/img/icons/icon_hot_sale_x2.png')" 
              />
            </div> -->
            <template v-else>
              {{ `${item.prefix || ''}${item.value || ''}` }}
              <BaseTipPopover v-if="item.tips" placement="top" :content="item.tips" />
            </template>
          </span>
        </li>
      </ul>
      <p v-else class="price-details__empty">
        还未有价格，请填写具体参数
      </p>
    </div>
    <!-- 优惠券 -->
    <div v-if="isShowBonus.show" class="price-details__coupon">
      <div>
        <template v-if="isShowBonus.value">
          优惠券 最高可减￥{{ isShowBonus.value }}
          <span>{{ bonusTips }}</span>
        </template>
        <span v-else >无可用优惠券</span>
        <img 
          :src="require('@@/assets/img/icons/icon_question3.png')" 
          @click="handleOpenCouponDialog"
        />
      </div>
    </div>
    <!-- 预估总价 -->
    <div class="price-details__total">
      <div v-if="isFpcNeedAudit">
        <span class="price-details__total__tips">
          （软硬结合板具体价格<span>以审核后为准</span>）
        </span>
        <span class="price-details__total__label">
          预估总价：
        </span>
        <span class="price-details__total__amount">
          <i>￥</i>
          ----
        </span>
      </div>
      <div v-else>
        <span class="price-details__total__tips">
          （仅供参考，最终价格以审核后为准）
        </span>
        <span class="price-details__total__label">
          预估总价：
        </span>
        <span class="price-details__total__amount">
          <i>￥</i>
          <QuoteAnimateNumber :num="priceTotal.total_amount" />
        </span>
      </div>
    </div>

    <!-- PCB优惠券弹框 -->
    <PcbCouponDialog ref="PcbCouponDialogRef" />
  </div>
</template>

<script>
// PCB优惠券弹框
import PcbCouponDialog from '@@/components/pcbCoupon/index'
// 数字跳动效果
import QuoteAnimateNumber from '@@/components/common/quoteAnimateNumber'

import { PRICE_FIELDS } from '@@/utils/constant'

export default {
  props: {
    priceTotal: {
      type: Object,
      default: () => ({})
    },
    // 产品类别
    board_type: {
      type: String,
      default: 'FR-4'
    },
    // 表面处理
    spray: {
      type: String,
      default: ''
    },
    // FPC 板子层数为 8 10 12 价格以审核为准
    isFpcNeedAudit: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PcbCouponDialog,
    QuoteAnimateNumber
  },
  computed: {
    isFpc() {
      return this.board_type === 'FPC'
    },
    list() {
      return this.getList()
    },
    // 是否显示优惠券
    isShowBonus() {
      const { total_amount, detail } = this.priceTotal
      if (
        total_amount > 0 && 
        detail && 
        detail.pcb && 
        detail.pcb.bonus_activity
      ) {
        // 预估总价 > 0 且 优惠券有数据
        const { usable_coupon, not_usable_coupon, optimum_coupon } = detail.pcb.bonus_activity
        if ([...(usable_coupon || []), ...(not_usable_coupon || [])].length > 0) {
          return { show: true, value: (optimum_coupon || {}).money }
        }
        return { show: false }
      }
      return { show: false }
    },
    // 优惠券提示
    bonusTips() {
      // 有活动折扣
      const hasDiscount = (this.list || []).find(item => item.label === '活动折扣')
      return hasDiscount ? '（在支付时可使用，与活动不同享）' : '（在支付时可使用）'
    }
  },
  methods: {
    getList() {
      const { priceTotal, spray, isFpc } = this
      const { detail, activity } = priceTotal || {}
      const data = (detail || {}).pcb || {}
      let fields = isFpc ? PRICE_FIELDS.FPC : PRICE_FIELDS.PCB

      // 活动折扣提示
      const { pcb = [] } = activity || {}
      const tips = [...pcb].map(item => `${item.title}：${item.amount}`).join(`\n`)

      // 需要加上额外的字段
      fields = Object.assign(fields, {
        insurancefee: 'PCB品质服务费',
        expressage: '运费',
        invoicefee: '税费',
        discount_amount: '活动折扣',
      })

      return Object.keys(fields)
        .filter(key => data[key] && +data[key] !== 0)
        .map(key => {
          let label = fields[key]
          let prefix = '￥'
          let slot
          // 表面处理
          if (key === 'sprayfee') {
            label = `${spray === 'OSP' ? 'OSP' : spray.substring(0, 2)}费`
          }
          // discount_amount - PCB活动折扣
          if (key === 'discount_amount') {
            return { label, value:  (+data[key] || 0).toFixed(2), prefix: '-￥', tips, color: '#E1251B' }
          }
          // 显示减工程费 减 提示 (engineering_standard_file: 0-无减免 1-有减免 2-有订单备注导致无减免)
          if (key === 'gch' && data.engineering_standard_file === 1) {
            slot = 'gch'
          }
          // 特价活动 工程费 改成 特价
          if (key === 'gch' && data.spec_discount === 1) {
            label = '特价'
          }
          // 叠层结构费 显示爆款标识
          // if (key === 'pressingfee' && data[key] < 0) {
          //   slot = 'pressingfee'
          // }
          return { label, value:  data[key] || '0.00', prefix, slot }
        })
    },
    handleOpenCouponDialog() {
      this.$refs.PcbCouponDialogRef.open(this.priceTotal.detail.pcb.bonus_activity)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@@/styles/mixin.scss';

.price-details {
  .price-details__header {
    padding: 10px 0 7px;
    font-size: 13px;
    font-weight: 700;
    color: $--color-text-important;
  }
  .price-details__content {
    padding: 6px 13px;
    border-radius: 3px;
    background-color: #F9F9F9;
    overflow: hidden;
  }

  .price-details__list {
    display: flex;
    flex-wrap: wrap;
    font-size: 13px;
    .price-details__item {
      display: flex;
      align-items: center;
      width: 50%;
      height: 26px;
      >span {
        box-sizing: border-box;
        display: block;
      }
      .price-details__item__label {
        flex-shrink: 0;
        width: 92px;
        color: #7F7F7F;
      }
      .price-details__item__value {
        flex: 1;
        display: flex;
        align-items: center;
        color: #1A1A1A;
        // overflow: hidden;
        // text-overflow: ellipsis;
        white-space: nowrap;
        .base-tip-popover__icon {
          margin-left: 4px;
        }
      }

      .price-details__item__gch {
        position: relative;
        .price-details__item__gch__reference {
          position: absolute;
          top: -10px;
          // right: -8px;
          font-size: 12px;
          color: #F65001;
        }
      }

      .price-details__item__pressingfee {
        position: relative;
        .price-details__item__pressingfee__hot {
          position: absolute;
          top: -12px;
          right: -42px;
          display: block;
          width: 56px;
          // height: 16px;
        }
      }
    }
  }

  .price-details__empty {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    line-height: 26px;
    font-size: 12px;
    color: #aaa;
    &.fpc-audit {
      text-align: center;
      >span {
        display: block;
        width: 100%;
      }
    }
  }

  .price-details__coupon {
    display: flex;
    justify-content: flex-end;
    margin-top: 7px;
    >div {
      display: flex;
      align-items: center;
      padding: 0 9px;
      height: 24px;
      font-size: 12px;
      color: #C5792B;
      border-radius: 5px;
      background-color: #FFF4E3;
      >span {
        color: #999999;
      }
      >img {
        display: block;
        margin-left: 4px;
        width: 12px;
        cursor: pointer;
      }
    }
  }

  .price-details__total {
    display: flex;
    justify-content: flex-end;
    margin-top: 5px;
    >div {
      display: flex;
      align-items: flex-end;
    }
    .price-details__total__tips {
      font-size: 12px;
      color: #AAAAAA;
      @include ellipsis;
      >span {
        color: $--color-warning;
      }
    }
    .price-details__total__label {
      flex-shrink: 0;
      margin-right: -5px;
      font-size: 13px;
      font-weight: 700;
      color: #111111;
    }
    .price-details__total__amount {
      flex-shrink: 0;
      margin-bottom: -2px;
      font-size: 18px;
      font-weight: 700;
      color: #D9001B;
      >i {
        font-size: 14px;
      }
    }
  }
}
</style>